import { AdministratorAPI } from "../constants/apiRoutes";
import { securityActions } from "../reducers/security";
import apiService from "../utils/configAxios";

import "react-toastify/dist/ReactToastify.css";
import { handleError } from "../utils/handleError";
import { isEmployee, setStoredLoggedUser } from "../utils/auth";

export const login = (data, navigate) => {
  return (dispatch) => {
    dispatch(securityActions.actionStart());

    return apiService
      .post(AdministratorAPI.login(), data)
      .then((response) => {
        // Očekujemo da BE vrati user objekt (bez tokena)
        setStoredLoggedUser(response.data);
        dispatch(securityActions.setCurrentUser(response.data));
        navigate(isEmployee(response.data) ? "/receipt-list" : "/dashboard");
      })
      .catch((err) => {
        handleError(err);
        setStoredLoggedUser(null);
        dispatch(securityActions.clearUser());
      });
  };
};

// GET /auth/me – BE vrati user-a ako je sesija važeća, ili 401
export const checkAuth = () => {
  return (dispatch) => {
    return apiService
      .get(AdministratorAPI.me())
      .then((response) => {
        setStoredLoggedUser(response.data);
        dispatch(securityActions.setCurrentUser(response.data));
      })
      .catch((err) => {
        setStoredLoggedUser(null);
        dispatch(securityActions.clearUser()); // ← OVO JE KLJUČ
      });
  };
};

export const logout = (navigate) => {
  return (dispatch) => {
    return apiService.post(AdministratorAPI.logout()).finally(() => {
      setStoredLoggedUser(null);
      dispatch(securityActions.clearUser());
      navigate("/");
    });
  };
};
